module.exports = __webpack_public_path__ + "static/media/brazil.a102e563.svg";